import { Pipe, PipeTransform } from '@angular/core';
import { Status } from '../shared/helpers/status.helper';

@Pipe({
    standalone: true,
    name: 'statusToString'
})
export class StatusToStringPipe implements PipeTransform {

    transform(status : Status): string {
        let statusStr = "";
        switch (status) {
            case 0:
                statusStr = "Eliminado";
                break;
            case 1:
                statusStr = "Inactivo";
                break;        
            default:
                statusStr = "Activo";
                break;
        }
        return statusStr;
    }
}